/*
  Flechas del mosaico de temáticas (sections/cs-catalogo.liquid).

  El desplazamiento de verdad lo hace el CSS: `.cs-mosaico` es un carrusel con
  `scroll-snap`, así que en móvil ya se pasa de página arrastrando con el dedo
  y sin una línea de JavaScript. Esto de aquí solo añade las flechas para
  quien va con ratón, y apaga la que no lleva a ninguna parte.

  Por eso, si este archivo no llega a cargarse, no se rompe nada: se puede
  seguir pasando de página a mano. Las flechas son un extra, no el mecanismo.
*/
(function () {
  var UMBRAL = 4; // px de tolerancia: los navegadores no clavan el scrollLeft

  function preparar(mosaico) {
    var caja = mosaico.closest('.cs-mosaico-caja');
    if (!caja) return;

    var flechas = caja.querySelectorAll('[data-cs-mosaico-ir]');
    if (!flechas.length) return;

    function pintarFlechas() {
      var maximo = mosaico.scrollWidth - mosaico.clientWidth;
      flechas.forEach(function (flecha) {
        var sentido = Number(flecha.dataset.csMosaicoIr);
        // La misma trampa de siempre: `hidden` no basta si la clase trae un
        // `display` explícito. Ver la regla .cs-mos__flecha[hidden] del CSS.
        flecha.hidden =
          sentido < 0 ? mosaico.scrollLeft <= UMBRAL : mosaico.scrollLeft >= maximo - UMBRAL;
      });
    }

    flechas.forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        // Una página entera por clic: el ancho visible del carrusel es
        // exactamente una página, porque cada `.cs-mosaico__pag` mide 100%.
        mosaico.scrollBy({
          left: mosaico.clientWidth * Number(flecha.dataset.csMosaicoIr),
          behavior: 'smooth',
        });
      });
    });

    mosaico.addEventListener('scroll', pintarFlechas, { passive: true });
    window.addEventListener('resize', pintarFlechas);
    pintarFlechas();
  }

  function arrancar() {
    document.querySelectorAll('[data-cs-mosaico]').forEach(preparar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de temas vuelve a pintar la sección sin recargar la página.
  document.addEventListener('shopify:section:load', arrancar);
})();
